// extracted by mini-css-extract-plugin
export default {"editApplicationRoot":"EditApplication_editApplicationRoot__WFhGm"};